<template>
  <tbody>
    <template v-if="data.length">
      <template v-for="item in data">
        <tr v-bind:key="item.id">
          <td v-if="shouldRenderSelection">
            <multi-select :selection="selection" :row="item" />
          </td>
          <td v-for="col in shownCols" :class="col.tdClass" :style="col.tdStyle" v-bind:key="col.field">
            <component
              v-if="col.tdComp"
              :is="forDynCompIs(col.tdComp)"
              :row="item"
              :field="col.field"
              :value="item[col.field]"
              :nested="item.__nested__"
              v-bind="$props">
            </component>
            <template v-if="['created_at', 'updated_at', 'createdAt', 'updatedAt', 'deleted_at', 'restored_at', 'date'].includes(col.field) && item[col.field] !== null">
              {{ new Date(item[col.field]).toLocaleDateString() }}
            </template>
            <template v-else-if="col.field==='photo_time' && item[col.field] !== null">
              {{ new Date(item[col.field]).toLocaleTimeString() }}
            </template>
            <template v-else-if="typeof item[col.field] === 'boolean' && item[col.field] !== null">
              {{ (item[col.field]) ? 'Ja' : 'Nein' }}
            </template>
            <template v-else-if="typeof item[col.field] === 'object' && item[col.field] !== null">
              {{ item[col.field].join(', ') }}
            </template>
            <template v-else-if="col.field==='photo_path' && item[col.field] !== null">
              <vue-pure-lightbox
                style="width: 4em"
                :thumbnail="getListOfImages(item[col.field])[0]"
                :images="getListOfImages(item[col.field])"
              ></vue-pure-lightbox>
              <center v-if="getListOfImages(item[col.field]).filter(im => im).length" style="text-align: center;">
                ( {{ getListOfImages(item[col.field]).filter(im => im).length }} )
              </center>
            </template>
            <template v-else-if="typeof item[col.field] === 'number' && item[col.field] !== 'null'">
              {{ Math.round(item[col.field] * 10) / 10 }}
            </template>
            <template v-else-if="item[col.field] !== 'null'">
              {{ item[col.field] }}
            </template>
          </td>
          <td v-if="Pagination && !isTrashBin">
            <template> <a href="#" @click.prevent="populatePostToEdit(item)">Bearbeiten</a> </template>
          </td>
          <td v-if="Pagination && !isTrashBin">
            <template> <a href="#" @click.prevent="deletePost(item)">Löschen</a> </template>
          </td>
        </tr>
        <transition name="fade" v-bind:key="item.id">
          <tr v-if="item.__nested__ && item.__nested__.visible">
            <td :colspan="colLen">
              <!-- nested component -->
              <component
                :is="forDynCompIs(item.__nested__.comp)"
                :row="item"
                :nested="item.__nested__"
                v-bind="$props">
              </component>
            </td>
          </tr>
        </transition>
      </template>
    </template>
    <tr v-else-if="!leftFixed && !rightFixed">
      <td :colspan="colLen" class="text-center text-muted">
        ( {{ $i18nForDatatable('Keine Daten vorhanden') }} )
      </td>
    </tr>
  </tbody>
</template>
<script>
import MultiSelect from './MultiSelect.vue'
import props from '../_mixins/props'
import shouldRenderSelection from '../_mixins/shouldRenderSelection'
import VuePureLightbox from 'vue-pure-lightbox' // For photos
import api from '@/api'
import './VuePureLightbox.css'
import config from '@/config.json'
import helpers from '@/mixins/helper-functions'

export default {
  name: 'TableBody',
  components: {
    MultiSelect,
    VuePureLightbox
  },
  mixins: [props, shouldRenderSelection],
  data () {
    return {
      objectKeys: ['concentration'] + config.exudats.proliferation.tableHeader.filter(head => head.input_type === 'Experiment').map(head => head.db_key)
    }
  },
  computed: {
    colLen () {
      return this.columns.length + !!this.selection
    },
    shownCols () {
      return this.columns.filter(col => !['edit', 'delete'].includes(col.field))
    }
  },
  methods: {
    getListOfImages (pathstring) {
      return pathstring.split(',').map(im => im.replace('mounted_data', '/static'))
    },
    populatePostToEdit (item) {
      this.$router.push({ params: { id: '' + item.id } })
    },
    async deletePost (item) {
      var canDelete = await helpers.canBeDeleted(item, this.$route, true)
      if (canDelete && confirm(`Möchten Sie den Eintrag ${item.option || item.exudate || item.day_id || item.patient_id} wirklich löschen?`)) {
        const deleteRoute = (this.isTrashBin) ? helpers.getPostResource(this.$route) : helpers.getPostResource(this.$route).replace('exudats/', '')
        // var status = await api.deletePost(deleteRoute, item.id)
        var status = await api.moveToTrashOrRestore(deleteRoute, [item.id], this.$route.path.includes('exudats'), false)
        this.createDeleteFeedback(item, status)
        this.$router.go() // Refresh page
      }
    },
    createDeleteFeedback (item, status) {
      if (status.err) {
        alert(`Der Eintrag ${item.option || item.day_id || item.patient_id} konnte nicht gelöscht werden - ${status.err}`)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Datatable/src/Table/TableBody.vue